
const Enums = {
    AssetTypes: {
        HVACR: 1,
        LeakMonitoringDevice: 2,
        VirginCylinder: 3,
        RecoveryCylinder: 4,
        Bottle: 5,
        RecoveryEquipment: 6,
        GasInsulatedBreakerSwitchGear: 7,
        Breaker: 8,
        ControlsControl: 9,
        PlumbingFixtures: 10,
        SewerDrain: 11,
        CompressorRack: 12,
        WaterHeater: 13,
        Meter: 14,
        Evaporator: 18,
        Condensor: 19,
        BackflowPreventer: 20,
        GeneralInventory: 21,
        Refrigeration: 22,
        WaterCoolingTower: 23,
        WaterHeaters: 24,
        EyewashStation: 26,
        DecorativeFountain: 28,
        ComfortCooling: 31,
        Generator: 45,
        Dumpster: 46,
        SepticTank: 47,
        SF6GasInsulatedSwitchGear: 55,
        SF6TransmissionEquipment: 57,
        SF6GasRecoveryCart: 58,
        SF6GasInsulatedCircuitBreaker: 59,
        SF6GIS: 60,
        SF6TwoPressureBreaker: 61,
        ProcessCooling: 63,
        GreaseTrap: 65,
        Heating: 66,
        GasRecoveryCart: 67
    },
    UserTypes: {
        SystemAdministrator: 1,
        TenantAdministrator: 2,
        RegionalAdministrator: 3,
        PurchasingAdministrator: 4,
        SubstationAdministrator: 5,
        Technician: 6,
        ReadOnly: 8,
        TechnicianManager: 9,
        Informational: 10,
        ReclaimAccounting: 11,
        ReclaimCSR: 12,
        ReclaimLab: 13,
        ReclaimReadOnly: 14,
        ReclaimAssociationManager: 15,
        LocationManager: 16,
        Wholesaler: 17,
        ReclaimShipping: 18,
        ReclaimNeutronics: 19,
        ReclaimGasTech: 20,
        ReclaimAdministrator: 21,
        SuperTenantAdmin: 22,
        SustainabilityManager: 23,
        APIFacilityManager: 24
    },
    AccountTypes: {
        Tenant: 1,
        ContractorLite: 2,
        SF6: 4,
        Contractor: 8,
        Reclaim: 16
    },
    LocationStatus: {
        Operational: 1,
        Deactivated: 2
    },
    LocationType: {
        WholesalerSupplier: 1,
        ServiceLocation: 2,
        Warehouse: 3,
        TechnicianTruck: 4,
        EquipmentLocation: 5
    },
    ServiceEvents: {
        MaintenanceNoGas : 1,
        LeakInspection : 2,
        ServiceOrLeakRepair : 3,
        Install : 4,
        ShutdownMothball : 5,
        Retrofit : 6,
        LeakMonitorCalibration : 7,
        QuarterlyLeakInspection: 8,
        AnnualLeakInspection: 9,
        MonthlyLeakInspection : 10,
        Reinstall : 11,
        RecordVitalStats : 12,
        RecordRefrigerant : 13
    },
    SE: {
        CoolingApplianceStatus : {
            NormalOperation : 1,
            Mothballed : 2,
            SeasonalOperation : 3,
            SeasonalNonOperation : 4,
            ProvisionalNonOperation : 5,
            ShutdownRetired : 6,
            UnderRepair : 7,
            PlannedRetrofit : 8 ,
            Retrofitted : 9,
            DisposedDestroyed : 10,
            Sold : 11,
            PlannedRetirement : 13,
            Moved : 14 
        },
        AssetType : {
            Refrigeration : 22,
            ComfortCooling : 31,
            ProcessCooling : 63,
            GasInsulatedSwitchGear : 55,
            GasInsulatedCircuitBreaker : 59,
            LeakMonitoringDevice : 2
        },
        WorkItemType : {
            MaintenanceNoGas : 1,
            LeakInspection : 2,
            ServiceOrLeakRepair : 3,
            Install : 4,
            ShutdownMothball : 5,
            Retrofit : 6,
            LeakMonitorCalibration : 7,
            LeakInspection2 : 8,
            Reinstall : 11,
            RecordVitalStats : 12,
            RecordRefrigerant : 13,
            ServiceOrLeakRepair2 : 15,
            Decomissioned : 16,
            AirFilterChangeOut : 17,
            Move : 18
        },
        LeakDetectionMethod : {
            ALD : 1,
            BubbleTest : 2,
            Alternative : 4,
            DyeInject : 5,
            ElectronicUltrasonic : 6,
            Evacuation : 7,
            HalideDetector : 8,
            Pressure : 9,
            Other : 10,
            NoCheckNeeded : 11,
            BubbleTest : 12,
            SMUDElectronicUltrasonic : 13,
            SMUDHalideDetector : 14,
            SMUDPressure : 15,
            SMUDCamera : 16
        },
        LeakRepairDispositionType : {
            NoRepair : 1,
            RepairAttempted : 2,
            LeakRepaired : 3
        },
        RepairOutcomeType : {
            LeakRepaired : 1,
            LeakNotRepaired : 2,
            NoRepairAttempted : 3
        },
        AssetStatus : {
            Active : 1,
            Inactive : 2,
            Decomissioned : 3
        },
        MaterialType : {
            SF6 : 82
        }
    },
    WorkItemStatusTypes: {
        Open: 1,
        WorkComplete: 2,
        Closed: 3,
        Cancelled: 4
    },
    WorkOrderTypes: {
        ScheduledMaintenance: 1,
        TroubleProblemTicket: 2,
    },
    WorkOrderStatusTypes: {
        Open: 1,
        WorkComplete: 2,
        Closed: 3,
        Cancelled: 4
    },
    ServiceTransferReasonTypes: {
        LeakRepair: 1,
        InitialCharge: 2,
    },
    UserPermissions : {
        SystemAdministrator: 1,
        ManageInventory: 8,
        ViewReports: 10,
        InputServiceEventData: 11,
        AddWorkOrder: 12,
        ViewUsers: 13,
        ManageLocations: 14,
        AddServiceEvent: 15,
        ManageUsers: 16,
        ViewLocations: 17,
        ReopenClosedServiceEvent: 18,
    },
    CommentType: {
        Asset: 1,
        WorkOrder: 2
    },
    LoginType: {
        SSO: 1, // Azure
        Trakref: 2
    }
};

export default Enums;